import React from 'react';
import ItemCheckbox from '../../Common/checkbox';

const SeleccionSucursales = ({ listadoSucursales, sucursalesUsuario, edit, handleChangeSucursales = () => {} }) => {

  const [listado, setListado] = React.useState(sucursalesUsuario);

  const changeListado = (event, opcion) =>{
    event.stopPropagation();

    let updatedOptions = listado.slice();
    const valueExists = updatedOptions?.find(opt => opcion?.idSucursal === opt?.idSucursal);

    if (valueExists) {
      updatedOptions = updatedOptions.filter(opt => opcion?.idSucursal !== opt?.idSucursal);
    } else {
      updatedOptions.push(opcion);
    }

    setListado([...updatedOptions]);
    handleChangeSucursales([...updatedOptions]);
  }

  React.useEffect(() => {
    setListado(sucursalesUsuario)
  }, [sucursalesUsuario])
    
  return (
    <div>
      {listadoSucursales?.map((opcion) => 
        <div className='listaSucursales' onClick={(event) => {if(!edit) changeListado(event, opcion); else return}}>
          <ItemCheckbox id={opcion.idSucursal} checked={listado?.map(x => x.idSucursal).includes(opcion.idSucursal)} descripcion={opcion.nombre} edit={edit} />
        </div>
      )}
    </div>
  )}

export default SeleccionSucursales;
